import * as modules from './modules.js';
import { criteria } from './criteria.js';
import { generateStatusArray, generateComponentArray} from './helpers';

export const sections = [
	{
		display: "Project",
		store_key: "project_information",
		component: () => import('@/js/forms/funding-request/Project-Information')
	},
	{
		display: "Applicant",
		store_key: "applicant_information",
		component: () => import('@/js/forms/funding-request/Applicant-Information')
	},
	{
		display: "Property",
		store_key: "property_information",
		component: () => import('@/js/forms/funding-request/Property-Information')
	},
	{
		display: "Acquisition",
		store_key: "acquisition_information",
		component: () => import('@/js/forms/funding-request/Acquisition-Information')
	},
	{
		display: "Market Value",
		store_key: "fair_market_value",
		component: () => import('@/js/forms/funding-request/Fair-Market-Value')
	},
	{
		display: "Budget",
		store_key: "project_budget",
		component: () => import('@/js/forms/funding-request/project-budget/')
	},
	{
		display: "Criteria",
		store_key: "project_criteria",
		component: () => import('@/js/forms/funding-request/project-criteria/')
	},
	{
		display: "Attachments",
		store_key: "attachments",
		component: () => import('@/js/forms/funding-request/Attachments')
	},
	{
		display: "Agreement",
		store_key: "agreement",
		component: () => import('@/js/forms/funding-request/Agreement')
	}
];

export const status_array = generateStatusArray(sections);
export const component_array = generateComponentArray(sections);

export default {
	...modules,
	criteria
}
